import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Countries, DefaultTablePagination, DisplayDate } from '../../../components/_utils/appUtils'

import { TableComp } from 'sz-react-utils-lite'
import { JournalList } from '../../journals/actions'
import lodash from 'lodash'
import { Button, Col, Form, Input, Row } from 'antd'
import { onlineSubmissionSearchResultFxn } from '../../article/actions'

const statusFilter = [
  'Pending',
  'Proceed',
  'Not Fit',
  'Another Journal',
  'Schedule',
  'As per format',
  'Withdraw',
  'Delete'
]
const issueTypeList = [
  'Regular Issue', 'Special Issue'
]
const OnlineSubmissionComp = (props) => {
  const dispatch = useDispatch()
  let tableRef = useRef()
  const [searchTerm, setSearchTerm] = useState(props.defaultSearchTerm || '')
  const [journals, setJournals] = useState([])
  let [total, setTotal] = useState(0)
  let apiRequest = (params) => {
    return new Promise(async resolve => {
      if (searchTerm && searchTerm.trim().length >= 3) {
        params.query = searchTerm
        let resp = await dispatch(onlineSubmissionSearchResultFxn(params))
        setTotal(resp.total)
        resolve(resp)
      } else {
        setTotal(0)
        resolve({})
      }
    })
  }

  useEffect(() => {
    loadJournalList()
    if (props.defaultSearchTerm) {
      setTimeout(() => {
        if(tableRef.current) tableRef.current.reload();
      }, 500);
    }
  }, [])

  let loadJournalList = async () => {
    let { data } = await JournalList()
    let journals = []
    lodash.each(data, item => {
      journals.push({ text: item.name, value: item.name, journalId: item._id })
    })
    setJournals(journals)
  }


  const columns = [
    // {
    //   title: 'ID',
    //   key: 'onlineSubmissionId',
    //   dataIndex: 'onlineSubmissionId',
    //   filterRegex: true,
    //   searchTextName: 'onlineSubmissionId',
    //   width: 75
    // },
    {
      title: 'ID',
      key: 'onlineSubmissionNo',
      dataIndex: 'onlineSubmissionNo',
      filterRegex: true,
      searchTextName: 'onlineSubmissionNo',
      width: 75,
      render: (text, record) => {
        return record.onlineSubmissionId || text || '-';
      }
    },
    {
      title: 'Date',
      width: 100,
      key: 'createdAt',
      dataIndex: 'createdAt',
      searchDateName: 'createdAt',
      render: item => {
        return DisplayDate(item)
      }
    },
    {
      title: 'Journal',
      key: 'journal',
      dataIndex: 'journal',
      filters: journals,
      width: 150
    },
    {
      title: 'Issue Type',
      key: 'issueType',
      dataIndex: 'issueType',
      width: 120,
      filters: issueTypeList.map(x => ({ text: x, value: x }))
    },
    {
      title: 'Manuscript Title',
      key: 'manuScriptTitle',
      dataIndex: 'manuScriptTitle',
      filterRegex: false,
      searchTextName: 'manuScriptTitle',
      width: 250,
      render: (item, record) => {
        return (
          <a
            onClick={() => {
              this.setState({
                submissionDrawerVisible: true,
                drawerData: record
              })
            }}>
            {item}
          </a>
        )
      }
    },
    {
      title: 'Country',
      key: 'country',
      dataIndex: 'country',
      width: 150,
      searchTextName: 'country',
      filters: Countries.map(x => ({ text: x.name, value: x.name })),
      render: (item, record) => {
        return (
          <div>
            <p>{item}</p>
            <p>{record.correspondingAuthorAffiliation}</p>
          </div>
        )
      }
    },
    {
      title: 'Corresponding Author',
      key: 'correspondingAuthor',
      dataIndex: 'correspondingAuthor',
      filterRegex: true,
      width: 150,
      searchTextName: 'correspondingAuthor'
    },
    {
      title: 'Author Email',
      width: 150,
      key: 'correspondingAuthorsEmail',
      dataIndex: 'correspondingAuthorsEmail',
      filterRegex: true,
      searchTextName: 'correspondingAuthorsEmail'
    },
    {
      title: 'Attachments',
      key: 'manuscriptAttachment',
      dataIndex: 'manuscriptAttachment',
      width: 150,
      render: (item, record) => {
        let { otherAttachment } = record
        return (
          <>
            {item && item.path ? (
              <a href={`${item.path}`} target={'_blank'}>
                Manuscript Attachments
              </a>
            ) : null}
            {otherAttachment && otherAttachment.path ? (
              <>
                <br />
                <br />{' '}
                <a href={`${otherAttachment.path}`} target={'_blank'}>
                  Other Attachments
                </a>
              </>
            ) : null}
          </>
        )
      }
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      width: 150,
      filters: statusFilter.map(x => ({ text: x, value: x }))
    }
  ]

  const searchArticle = async () => {
    setTimeout(() => {
      tableRef.current.reload()
    }, 300)
  }
  const clearFxn = () => {
    setSearchTerm('')
    setTimeout(() => {
      tableRef.current.reload()
    }, 300)
  }

  return (
    <div>

      <Form hideRequiredMark className={'inputForm'} style={{ marginBottom: '30px' }}>
        <Row gutter={16}>
          <Col span={6}>
            <Input className={'antInputSearch'}
                   placeholder={'Search your Author Email, name and article title'}
                   style={{ marginRight: '10px' }}
                   value={searchTerm}
                   onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>
          <Col span={12}>
            <Button key='1' type='primary'
                    onClick={searchArticle}
                    style={{ marginRight: '10px' }}>
              Search
            </Button>
            <Button key='2'
                    type='primary'
                    onClick={clearFxn}>
              Clear
            </Button>
          </Col>
          <Col span={6}>
            <div className={'align-right'}>
              Total - {total}
            </div>
          </Col>
        </Row>
      </Form>


      <TableComp
        ref={tableRef}
        columns={columns}
        apiRequest={apiRequest}
        extraProps={{ scroll: { x: 1200 } }}
        pagination={DefaultTablePagination({}, 50)}
      />
    </div>
  )
}
export default OnlineSubmissionComp
